import PropTypes from 'prop-types'
import styles from './CalificacionProducto.module.css'
import Opiniones from './Opiniones'

const MAX_ESTRELLAS = 5

const CalificacionProducto = (props) => {
  const arrayCalificacionPromedio = props.calificacion.map((e) => e.promedioCalificacion)
  const calificacionPromedio = arrayCalificacionPromedio[0]

  return (
    <div className={styles.calificacionProducto}>
      <p className={styles.tituloDetalle}>Opiniones del Producto</p>
      <div className={styles.informacion}>
        <div className={styles.resumen}>
          <p className={styles.puntuacion}>Puntuación promedio:</p>
          <span className={styles.estrellas}>
            {[...Array(MAX_ESTRELLAS)].map((_, i) => (
              <i
                key={i}
                className={`fa ${i < calificacionPromedio ? 'fa-star' : 'fa-star-o'} ${styles.yellowStar}`}
                aria-hidden="true"
              ></i>
            ))}
          </span>
        </div>
        {props.calificacion.length === 0 ? (
          <p className={styles.sinOpiniones}>Todavía no hay opiniones para mostrar</p>
        ) : (
          <div className={styles.opinionesLista}>
            {props.calificacion.map((e) => (
              <Opiniones
                key={e.idCalificacion}
                calificacion={e.calificacionAlItem}
                comentario={e.comentario}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  )
}

CalificacionProducto.propTypes = {
  calificacion: PropTypes.arrayOf(
    PropTypes.shape({
      idCalificacion: PropTypes.number.isRequired,
      promedioCalificacion: PropTypes.number.isRequired,
      calificacionAlItem: PropTypes.number.isRequired,
      comentario: PropTypes.string.isRequired
    })
  ).isRequired
}

export default CalificacionProducto
